var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"classify"},[_c('Tree',{ref:"treeDom",attrs:{"data":_vm.classify_data,"show-checkbox":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }